// import axios from 'axios';
import api from '@/api';
import {
//
} from './mutation-types';

export default {
    // eslint-disable-next-line no-unused-vars
    issueBadge ({ commit }, issue) {
        issue.language = issue.lang;
        issue.company = 'bgwc3lecos';
        console.log('action! bgwc3lecos', issue);
        // https://lecos.co.kr/api/v1/OpenBadges
        return api.post('/OpenBadgesV3', issue, {
            headers: {
                'Accept-Language': issue.lang
            },
        });
    },
};
